//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TimeZoneInfoDisplayItem extends ItemBase {
    DisplayName: string | null = null;
    ID: string | null = null;
    UTCOffsetInMinutes: number = 0;

    constructor(initializer?: Partial<TimeZoneInfoDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TimeZoneInfoDisplayItem";
}
